import React from 'react';

const PreviousNextStop = (props) => {
   return (
       <div className="right">
            <button className={`previous-next-button inline-block ${props.currentStop === 1 ? 'disabled' : ''}`} onClick={() => props.onPreviousClicked()}>
                <svg className="mr1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="18" height="18">
                    <path fill="currentColor" d="M152.485 396.284l19.626-19.626c4.753-4.753 4.675-12.484-.173-17.14L91.22 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H91.22l80.717-77.518c4.849-4.656 4.927-12.387.173-17.14l-19.626-19.626c-4.686-4.686-12.284-4.686-16.971 0L3.716 247.515c-4.686 4.686-4.686 12.284 0 16.971l131.799 131.799c4.686 4.685 12.284 4.685 16.97-.001z"></path>
                </svg>
                <span className="uppercase bold f-size-12">Previous Stop</span>
            </button>

            <span className="bold f-size-14 pl2 pr2"> {props.currentStop} / {props.totalStops} </span>    

            <button className={`previous-next-button inline-block ${props.currentStop === props.totalStops ? 'disabled' : ''}`} onClick={() => props.onNextClicked()}>
                <span className="uppercase bold f-size-12">Next Stop</span>    
                <svg className="ml1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="18" height="18">
                    <path fill="currentColor" d="M295.515 115.716l-19.626 19.626c-4.753 4.753-4.675 12.484.173 17.14L356.78 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h344.78l-80.717 77.518c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l131.799-131.799c4.686-4.686 4.686-12.284 0-16.971L312.485 115.716c-4.686-4.686-12.284-4.686-16.97 0z"></path>
                </svg>
            </button>
       </div>
   ) 
}

export default PreviousNextStop;